import { render, staticRenderFns } from "./ModalCertificateOT.vue?vue&type=template&id=56032484&"
import script from "./ModalCertificateOT.vue?vue&type=script&lang=js&"
export * from "./ModalCertificateOT.vue?vue&type=script&lang=js&"
import style0 from "./ModalCertificateOT.vue?vue&type=style&index=0&id=56032484&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports